import { ParentType } from '@risksmart-app/drizzle/src/types/consts/parent-types.js';

export const NAVIGATION_PARENT_TYPES: Partial<Record<ParentType, ParentType>> =
  {
    [ParentType.InternalAuditEntity]: ParentType.InternalAuditEntity,
    [ParentType.InternalAuditReport]: ParentType.InternalAuditReport,
    [ParentType.Risk]: ParentType.Risk,
    [ParentType.Appetite]: ParentType.Risk,
    [ParentType.Acceptance]: ParentType.Risk,
    [ParentType.Document]: ParentType.Document,
    [ParentType.Obligation]: ParentType.Obligation,
    [ParentType.ComplianceMonitoringAssessment]:
      ParentType.ComplianceMonitoringAssessment,
    [ParentType.ThirdParty]: ParentType.ThirdParty,
    [ParentType.Issue]: ParentType.Issue,
    [ParentType.IssueRiskEvent]: ParentType.Issue,
    [ParentType.IssueBreachLog]: ParentType.Issue,
    [ParentType.IssueGdprBreachLog]: ParentType.Issue,
    [ParentType.IssuePciBreachLog]: ParentType.Issue,
    [ParentType.IssueSarLog]: ParentType.Issue,
    [ParentType.IssueConsumerDuty]: ParentType.Issue,
    [ParentType.IssueCustomerTrust]: ParentType.Issue,
    [ParentType.Indicator]: ParentType.Indicator,
    [ParentType.Assessment]: ParentType.Assessment,
    [ParentType.EnterpriseRisk]: ParentType.Risk,
    [ParentType.Control]: ParentType.Control,
    [ParentType.Action]: ParentType.Action,
    [ParentType.ControlGroup]: ParentType.ControlGroup,
    [ParentType.AttestationRecord]: ParentType.Document,
    [ParentType.RiskControlledInternalAuditResult]:
      ParentType.InternalAuditEntity,
    [ParentType.RiskUncontrolledInternalAuditResult]:
      ParentType.InternalAuditEntity,
    [ParentType.DocumentInternalAuditResult]: ParentType.InternalAuditEntity,
    [ParentType.ObligationInternalAuditResult]: ParentType.InternalAuditEntity,
    [ParentType.UncontrolledRiskAssessmentResult]:
      ParentType.InternalAuditEntity,
    [ParentType.QuestionnaireTemplate]: ParentType.ThirdParty,
    [ParentType.ThirdPartyResponse]: ParentType.ThirdParty,
    [ParentType.TestResult]: ParentType.Control,
    [ParentType.Cause]: ParentType.Issue,
    [ParentType.Consequence]: ParentType.Issue,
    [ParentType.AssessmentActivity]: ParentType.Assessment,
    [ParentType.RiskAssessmentResult]: ParentType.Assessment,
    [ParentType.DocumentAssessmentResult]: ParentType.Assessment,
    [ParentType.ObligationAssessmentResult]: ParentType.Assessment,
    [ParentType.CustomDatasource]: ParentType.CustomDatasource,
    [ParentType.Impact]: ParentType.Impact,
    [ParentType.ImpactRating]: ParentType.Impact,
  };
